export const APP_NAME = 'tailored_homepage_perseus';
export const PAGE_NAME = 'tailored_homepage';
